import UpperSection from "../components/Attraction/UpperSection";

export default function AttractionPage(){
    return (
        <>
            <UpperSection/>
        </>
    )
}